import { useEffect } from "react";
// A real, recurring bug on iOS Safari: rubber-band overscroll reveals the actual <html>/<body>
// background (the browser's own default white) past whatever a page's own root element paints --
// `overscroll-behavior: none` on that root stops the bounce itself, but doesn't stop the brief
// white flash at the very top/bottom edge during the bounce. This covers that gap defensively by
// making the underlying document background match for as long as the page using it is mounted,
// restoring whatever was there before on unmount. First built for VoiceOrbExperience.tsx (always
// dark, a fixed color regardless of system theme); pulled out here so every assistant/pals
// experience gets the same fix by default rather than each one having to remember to add it --
// AssistantChatPage.tsx (the single shared entry point for every presentation_type, current and
// future) calls this once for all of them, matching its own light/dark-aware `--canvas` token.
export function useMatchDocumentBackground(color) {
    useEffect(() => {
        const prevHtmlBg = document.documentElement.style.background;
        const prevBodyBg = document.body.style.background;
        document.documentElement.style.background = color;
        document.body.style.background = color;
        return () => {
            document.documentElement.style.background = prevHtmlBg;
            document.body.style.background = prevBodyBg;
        };
    }, [color]);
}
